export function hasContent(s: string): boolean {
  if (s === undefined || s === null || s.length === 0) {
    return false
  } else {
    const trimmed = s.trim()
    return trimmed !== ''
  }
}

export function stripCharactersFromPhoneNumber(s: string): string {
  return s.replace(/[-+()\s]/g, '')
}
